import { useState } from "react";

export default function DocumentLogSection() {
  const [activeCategory, setActiveCategory] = useState("All");

  const documents: any[] = [];

  const categories = ["All", "Mall Information", "Warning Letter", "Invoice"];

  const visibleDocs =
    activeCategory === "All"
      ? documents
      : documents.filter((d) => d.category === activeCategory);

  return (
    <div className="w-full h-full">
      <div className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-700 h-full flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between gap-4 mb-3 flex-wrap">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white flex-shrink-0">
            Document Log
          </h3>
          <div className="flex items-center gap-2 overflow-x-auto pb-1 sm:pb-0 scrollbar-none">
            {categories.map((cat) => {
              const active = cat === activeCategory;
              return (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`whitespace-nowrap flex-shrink-0 px-3 py-1.5 rounded-full text-sm font-medium transition-all ${active
                    ? "bg-blue-600 text-white shadow-sm"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
                    }`}
                >
                  {cat}
                </button>
              );
            })}
          </div>
        </div>

        {/* Content — tinggi otomatis mengikuti data */}
        {visibleDocs.length === 0 ? (
          <div className="py-10 text-center flex-1 flex items-center justify-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Belum ada dokumen log.
            </p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100 dark:divide-gray-800">
            {visibleDocs.map((doc, idx) => (
              <div key={idx} className="flex items-center justify-between py-3 gap-4">
                <div className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                  {doc.date}
                </div>
                <div className="flex-1 text-sm text-gray-800 dark:text-gray-200">
                  {doc.description}
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                  {doc.category}
                </div>
                <button className="text-xs font-semibold text-gray-900 dark:text-white">
                  Download
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}